import React, { useRef, forwardRef } from 'react';
import { cn } from '@/lib/utils';
import Logo from '@/components/atoms/logo';
import Button from '@/components/atoms/button';
import Heading from '@/components/atoms/heading';
import Text from '@/components/atoms/text';
import FormHeaderTitle from '@/components/molecules/formHeaderTitle';
import ConfirmActionModal from '@/components/organisms/confirmActionModal';
import LloydsImg from '@/images/lloyds.png';
import MasterImg from '@/images/master.png';
import MaestroImg from '@/images/maestro.png';
import VisaImg from '@/images/visa.png';
import { Head } from '@inertiajs/react';

export default function FrontHeaderLayout({
	btnText,
	headerTitle,
	stepTitle,
	handleBackBtn,
	headerTitleVariant,
	children,
	className,
	hidePaymentMethods = false,
	hideFormHeader = false,
	showFormPriceFooter = false,
	pageTitle = null,
}) {
	const confirmModalRef = useRef();
	const currentYear = new Date().getFullYear();

	return (
		<>
			<Head title={pageTitle ?? 'My Account'} />

			<div className={cn('flex flex-col min-h-screen bg-white', className && className)}>
				<div className="border-b border-formOutline z-[10] bg-white fixed top-0 left-0 w-full">
					<div className="relative flex items-center justify-center px-6 mx-auto py-eis-13 md:py-6 md:px-10 lg:px-14 xl:px-eis-72 max-w-eis-1440">
						{btnText && (
							<Button
								variant="icon-and-underline"
								size="none"
								icon="chevron-left"
								iconAndUnderline="icon-and-underline"
								className="absolute -translate-y-1/2 left-6 md:left-10 lg:left-14 xl:left-eis-72 top-1/2 text-eis-black"
								textClassName="hidden md:block"
								onClick={handleBackBtn}
							>
								{btnText}
							</Button>
						)}

						<Button
							size="none"
							onClick={() => {
								if (confirmModalRef?.current) confirmModalRef.current.onOpen();
							}}
						>
							<Logo name="logo-big-colourful" className="w-eis-106 h-eis-30 md:w-eis-188 md:h-eis-51" />
						</Button>

						<Button
							variant="icon-and-underline"
							size="none"
							icon="phone"
							iconAndUnderline="icon-and-underline"
							className="absolute -translate-y-1/2 right-6 md:right-10 lg:right-14 xl:right-eis-72 top-1/2"
							textClassName="hidden md:block text-eis-black"
							iconClassName="text-corporateBlueBright"
						>
							Helpline: 01425 470360
						</Button>
					</div>
				</div>

				{!hideFormHeader && (
					<FormHeaderTitle variant={headerTitleVariant} title={headerTitle} subtitle={stepTitle} className="mt-14 md:mt-eis-99 min-h-eis-142" />
				)}

				{children}

				{!hidePaymentMethods && (
					<div className="py-8 bg-eis-light-blue-1">
						<div className="flex flex-col items-stretch px-6 mx-auto md:flex-row max-w-eis-1440 md:px-10 lg:px-14 xl:px-eis-72">
							<div className="flex flex-col items-center gap-4 text-center md:py-5 grow md:items-start md:text-left">
								<Heading type="h3" className="text-corporateBlue">
									Banks we accept
								</Heading>
								<Text type="p" variant="normal" className="text-corporateBlue">
									We insure tens of thousands of events all over the UK
								</Text>
							</div>
							<div className="grid grid-flow-col grid-cols-4 gap-2 md:gap-4">
								<img src={LloydsImg} alt="Lloyds bank logo" className="block object-contain w-full max-w-eis-120 max-h-eis-120" />
								<img src={MasterImg} alt="Master logo" className="block object-contain w-full max-w-eis-120 max-h-eis-120" />
								<img src={MaestroImg} alt="Maestro logo" className="block object-contain w-full max-w-eis-120 max-h-eis-120" />
								<img src={VisaImg} alt="Visa logo" className="block object-contain w-full max-w-eis-120 max-h-eis-120" />
							</div>
						</div>
					</div>
				)}

				<div className={cn('bg-eis-black', showFormPriceFooter && 'mb-40')}>
					<div className="flex flex-col w-full px-6 py-12 mx-auto md:px-10 lg:px-14 xl:px-eis-72 max-w-eis-1440">
						<Text type="small" variant="normal" className="text-white">
							Event Insurance Services is a limited company registered in England and Wales.
						</Text>
						<Text type="small" variant="normal" className="text-white">
							Registered number: 3238686 Event Insurance Services Limited are authorised and regulated by the Financial Conduct Authority, Ref No. 309998
						</Text>
						<Text type="small" variant="normal" className="mt-4 text-xs text-white">
							&copy; Copyright {currentYear} - Event Insurance Services. All rights reserved. Privacy and cookies
						</Text>
					</div>
				</div>
			</div>

			<ConfirmActionModal
				ref={confirmModalRef}
				contents={
					<>
						<Text type="span" variant="normal" className="block text-black mb-eis-18">
							If you return to Event Insurance home page, you will be leaving this quote, you can return to it at any time by retrieving from the email link.
						</Text>
						<Text type="span" variant="normal" className="text-black">
							Or log into your account: An account set up has been sent to our email address.
						</Text>
					</>
				}
				actionBtnText="Continue with quote"
				cancelBtnText="Exit quote"
				icon="success"
				iconClassName="text-notificationsSuccess"
				contentClasses="max-w-eis-513"
				isContentNarrow
				reverseBtnOrder
				onConfirm={(handleConfirmModalClose) => {
					// close the confirmation modal
					handleConfirmModalClose();
					window.location.href = '/dashboard';
					// window.history.go(-1);
					return false;
				}}
			/>
		</>
	);
}
